const CART_ITEMS = JSON.parse(document.getElementById('cart_items').textContent);
const svgWidth = 560;
const svgHeight = 164;
const input = document.getElementById('reg_name');
const MaxTextInput = 9;


const state = {
  text: {
    value: localStorage.getItem('reg') || "your reg",
    factor: MaxTextInput,
    FontSize: "75px",
    maxLenght: MaxTextInput,
  },
  image: {
    show: false,
    url: "",
    x: 82,
    y: "20%",
    width: "8%",
    height: "60%",
  },
  shape: {
    type: "normal",
    id: 0,
    x: 0,
    y: 0,
    width: 480,
    height: 132,
    radius: 10,
  },
  badge: {
    type: "rect",
    color: "transparent",
    show: false,
    value: "none",
    width: 45,
  },
  border: {
    show: 'no',
    color: 'black',
  },
  cart: {
    size: null,
    style: null,
    font: null,
    border: null,
    badge: null,
    fittings: null,
  },
  changeWidth: {
    enable: false,
    minLength: 3,
    add: 100,
    ratio: localStorage.getItem('ratio') || 1,
  }
};

if (state.text.value !== '' && input) {
  input.value = state.text.value;
}


/// remove all unwanted characters
jQuery('#reg_name').bind('keyup blur', function () {
  var node = jQuery(this);
  node.val(node.val().replace(/[^a-zA-Z0-9 ]/g, ''));
  state.text.value = node.val();
  _autoWidth()
}
);

/// show the modal full screen
function showModal() {
  jQuery('#closeup').removeClass('hide');
}


// -------------------------
// close Modal
jQuery(".close-btn").on("click", function (e) {

  jQuery("#closeup").addClass("hide");
  e.preventDefault();

});

// -------------------------
// size options
jQuery(".selected-size").on("mouseup", function (e) {
  jQuery(".selected-size").not(this).next().removeClass("active");
  jQuery(this).next().toggleClass("active");
});

// -------------------------
// Fittings options
jQuery(".options_1").on("mouseup", function (e) {
  jQuery(".options_1").removeClass("selected");
  jQuery(this).addClass("selected");
});

jQuery(".options_2").on("mouseup", function (e) {
  jQuery(".options_2").removeClass("selected");
  jQuery(this).addClass("selected");
});

jQuery(".options_3").on("mouseup", function (e) {
  jQuery(".options_3").removeClass("selected");
  jQuery(this).addClass("selected");
});


// -------------------------
// On change of reg name
jQuery(".reg_name").on("keyup", function (e) {
  var textvalue = jQuery(this).val();
  changePlatesText(textvalue);
});
jQuery(".reg_name").on("mouseup", function (e) {
  var textvalue = jQuery(this).val();
  if (textvalue === "YOUR REG") {
    document.getElementById("reg_name").value = "";
  }
});

// -------------------------
// Plate options change
jQuery(".number").on("mouseup", function (e) {
  jQuery(".number").removeClass("selected");
  updatePlates(this, "number", e);
});

// -------------------------
// Badge options change
jQuery(".plate_badge").on("mouseup", function (e) {
  jQuery(".badge-container").removeClass("selected");
  updatePlates(this, "badge", e);
});


// -------------------------
// Border options change
jQuery(".border_option").on("mouseup", function (e) {
  jQuery(".border_option").removeClass("selected");
  updatePlates(this, "border", e)
});



function updatePlates(id, type, e) {

  var front_plate = document.getElementById("front_plate");
  var rear_plate = document.getElementById("rear_plate");
  var badgeBackground = jQuery(id).data("colour");
  var badgeImage = jQuery(id).data("image");
  var value = jQuery(id).data("value");

  jQuery(id).addClass("selected");

  switch (type) {

    /// plate number
    case "number":

      value ??= CART_ITEMS[0].options_with_values[1].value;

      if (value == "Both") {
        front_plate.classList.remove("hidden");
        rear_plate.classList.remove("hidden");
      } else if (value == "Front") {
        rear_plate.classList.add("hidden");
        front_plate.classList.remove("hidden");
      } else if (value == "Rear") {
        front_plate.classList.add("hidden");
        rear_plate.classList.remove("hidden");
      }
      break;

    // * plate badge
    case "badge":

      jQuery(id).parent().addClass("selected");

      value ??= CART_ITEMS[3].options_with_values[0].value;


      if (value === state.badge.value) return;

      state.badge.value = value;
      state.badge.color = badgeBackground || '';
      state.image.url = badgeImage || "";
      if (value === "None") {

        state.image.show = false;
        state.badge.show = false;
      } else if (value === "GREEN") {

        state.image.show = false;
        state.badge.show = true;
      } else {

        state.image.show = true;
        state.badge.show = true;
      }


      _toggleBadge();

      break;

    case 'badge_type':
      _toggleBadge()
      break;

    /// plate border
    case "border":

      value ??= CART_ITEMS[2].options_with_values[0].value;


      state.border.show = value == 'none' ? 'no' : 'yes';
      state.border.color = value;

      _toggleBorder();

  }
  document.getElementById("plateoption").value = value;
  if (e) e.preventDefault();

}

$("#autowidth").on("change", function (e) {
  state.changeWidth.enable = e.target.checked;
  _autoWidth();
})

$(".thumbnail").on("mouseup", function (e) {
  $(".select_size_container").removeClass("active");
})


// -------------------------
// Plate Size Change
function plate_sizechage(obj, value, text_field) {

  text_field ??= document.getElementById('reg_name').value;

  state.text.value = text_field;

  /// change the selected size image and text
  jQuery('.size_variant .selected-size img').attr('src', jQuery(obj).data("image"));
  jQuery('.size_variant .selected-size .select_size_text').text(jQuery(obj).data("value"));


  if (value) {
    var kind = value;
  } else {
    var kind = obj.dataset.value;
  }

  state.text.maxLenght = MaxTextInput;

  var id = 0;

  switch (kind) {
    case 'HEX PLATE (lambo style)':
      state.text.maxLenght = 8;
      id = 1;
      break;

    case 'Rover 75, Range R Sport, Jaguar x-type Estate':
      id = 2;
      break;

    case 'Range Rover Sport':
      id = 4;
      break;

    case 'Tapered Regular':
      id = 6;
      break;

    case "Oversize Hex":
      id = 7;
      break;

    case 'Jaguar S-Type Version 2':
      id = 3;
      break;

    case 'Rolls Royce Ghost':
      id = 5;
      break;

    case '20.5 inch Standard Size Plate':
      _createRect(401.25, 94.5);
      break;

    case '18 inch Short Plate':
      state.text.maxLenght = 8;
      _createRect(354, 94.5);
      break;

    case '16 inch Short Plate':
      state.text.maxLenght = 8;
      _createRect(315.75, 94.5);
      break;

    case '13 inch Short Plate':
      state.text.maxLenght = 6;
      _createRect(258.75, 94.5);
      break;

    case '21 inch x 6 inch Range Rover':
      _createRect(435, 136.5);
      break;

    case 'Standard UK 11x8 Square 4X4':
      _createRect(221.25, 163.5);
      break;
  }

  if (id !== 1) {
    $('.auto__width').css("display", "none");
    state.changeWidth.enable = false;
    state.changeWidth.ratio = 1;
    localStorage.setItem('ratio', 1);
    $('#autowidth').prop('checked', false);
    _autoWidth();
  } else {
    $('.auto__width').css("display", "");
  }

  if (id !== 0) {
    state.shape.id = id;
    state.shape.width = 480;
    _changeShape(id);
  }
}



// -------------------------
// Plate Style Change
function plate_stylechange(obj, value) {



  var under_texts = document.querySelectorAll("#front_under_text, #rear_under_text, #front_middle_text, #rear_middle_text");

  jQuery(".thumbnail-container").removeClass("selected");
  jQuery(obj).parent().addClass("selected");

  if (value) {
    var kind = value;
  } else {
    var kind = obj.dataset.value;
    const preImg = "https://cdn.shopify.com/s/files/1/0613/2783/5307/";
    const preVideo = "https://cdn.shopify.com/videos/c/vp/";
    const images = JSON.parse(obj.dataset.images);

    let index = 0;
    for (media of images) {
      const reg = /mp4/g;
      const type = reg.test(media) ? 'video' : 'img';
      let child = null;
      if (type === 'video') {
        // create video element
        child = document.createElement("video");

        // set attributes
        child.setAttribute("controls", "");

        // create source element
        const source = document.createElement("source");

        // set source attributes
        source.setAttribute("src", media);
        source.setAttribute("type", "video/mp4");
        child.setAttribute("style", "width:100%;");

        // append source to video element
        child.appendChild(source);
      } else if (type === 'img') {
        // create img element
        child = document.createElement("img");

        // set attributes
        child.setAttribute("style", "width:100%;");
        child.setAttribute("src", preImg + media);
      }
      index++
      jQuery(`.image_${index}`).empty();
      jQuery(`.image_${index}`).append(child);
    }
  }

  var plate_style_class = '';

  switch (kind) {
    case 'Gel':
      plate_style_class = '4d_gel_plate';
      break;
    case '3mm + Gel':
      plate_style_class = '4d_plate';
      break;
    case '5mm + Gel':
      plate_style_class = '4d_5mm_plate';
      break;
    case '8mm + Gel':
      plate_style_class = '4d_5mm_gel_plate';
      break;
    case '3mm Acrylic':
      plate_style_class = '3mm_Acrylic';
      break;
    case '5mm Acrylic':
      plate_style_class = '5mm_Acrylic';
      break;
    case '8mm Acrylic':
      plate_style_class = '8mm_Acrylic';
      break;
    case '10mm Acrylic':
      plate_style_class = '10mm_Acrylic';
      break;
  }
  if (!kind.includes("Acrylic")) {
    jQuery('#front_upper_text, #rear_upper_text').show();
    jQuery('.middle').css("color", "");
  }
  if (kind.includes("Acrylic")) {
    jQuery('#front_upper_text, #rear_upper_text').hide();
    jQuery('.middle').css("color", "#262626");
  }

  under_texts.forEach(element => {
    element.className = element.className.replaceAll(/\sstyle_[\w\d_]+/g, "");
  });
  // Update style effect
  under_texts.forEach(element => {
    element.classList.add("style_" + plate_style_class);
  });


}



function legalSpaceChange(obj, value) {

  jQuery('.legal__space .selected-size .select_size_text').text(jQuery(obj).data("value"));

  if (value) {
    var kind = value;
  } else {
    var kind = obj.dataset.value;
  }

  switch (kind) {
    case 'Road Legal spacing':
      state.text.maxLenght = MaxTextInput;
      input && (input.maxLength = MaxTextInput);
      break;

    default:
      state.text.maxLenght = 20;
      input && (input.maxLength = 20);

  }

}



function borderColorChange(obj) {

  /// change selected color
  jQuery('.color').removeClass('selected');
  jQuery(obj).addClass('selected');

  updatePlates(obj, "border");

}

/// change from normal badge to over badge
function badgeStyleChange(obj, value) {

  /// change the selected badge text
  jQuery('.badge-style .select_size_text').text(jQuery(obj).data("value"));

  updatePlates(obj, 'badge_type');

}


/// remove the error class
jQuery('#reg_name').keyup(function (e) {
  jQuery(this).removeClass('error');
  jQuery("#main-product-details .full_box.input").removeClass('error');
});


// confirm button clicked

function confirmClicked(obj) {
  var plateTextValue = document.getElementById("reg_name");
  var variantID = jQuery(".product-form input[name='id']").val();
  var autowidth = $('#autowidth').is(':checked');
  var id = obj.id;

  if (id == "size" && (plateTextValue.value == "" || plateTextValue.value == "YOUR REG")) {

    plateTextValue.classList.add('error');
    jQuery("#main-product-details .full_box.input").addClass('error');
    window.scroll(0, input.offsetTop - 54);

  } else {

    addOrUpdate(id, variantID, plateTextValue?.value, autowidth);

  }
}


const addOrUpdate = (stepId, variantID, reg_num, autowidth) => {

  let href = "";

  // add or update depend on id of elem
  switch (stepId) {
    case 'size':
      href = `${window.location.origin}/products/gel-4d-style`;
      checker(1);
      break;

    case 'style':
      href = `${window.location.origin}/products/gel-4d-border`;
      checker(2);
      break;

    case 'border':
      href = `${window.location.origin}/products/gel-4d-badge`;
      checker(3);
      break;

    case 'badge':
      href = `${window.location.origin}/products/gel-4d-plate-fittings`;
      checker(4);
      break;

    case 'fittings':
      href = `/cart`;
      checker(5);
      break;
  }


  function checker(num) {

    var item = (num == 1) ? { quantity: 1, id: variantID, properties: { Registration: reg_num, 'Auto Width': autowidth ? 'enabled' : 'disabled', stepId } } : { quantity: 1, id: variantID, properties: { stepId } };
    var body = { items: [...CART_ITEMS, item] };
    var variant_id = state.cart[stepId] ?? "";

    if (CART_ITEMS.length >= num) {

      body.items = [];
      /// ? Update Case
      for (let i = 0; i < CART_ITEMS.length; i++) {
        if (i == (num - 1)) {
          body.items[i] = item;
          continue;
        }
        body.items[i] = CART_ITEMS[i];
      }


    }

    body.items.reverse();
    // update from the cart
    jQuery.post('/cart/clear.js').then(() => {
      jQuery.post('/cart/add.js', body).then(() => {
        window.location.href = `${href}?variant=${variant_id}`;
      })
    });


  }

}
//
String.prototype.handle = function () {
  return this.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/\-$/g, '');
}

function clearCart() {
  jQuery.post('/cart/clear.js');
}

function deleteProduct(id) {
  const body = { quantity: 0, id };
  jQuery.post('/cart/add.js', body)
}

function updateAllFields() {

  /// to delete products
  const otherProducts = CART_ITEMS.filter(item => !item?.properties?.stepId)

  if (otherProducts.length) {
    for (product of otherProducts) {
      deleteProduct(product.variant_id)
    }
  }

  const page_one = CART_ITEMS.find(item => item.properties.stepId === "size");
  const page_two = CART_ITEMS.find(item => item.properties.stepId === "style");
  const page_three = CART_ITEMS.find(item => item.properties.stepId === "border");
  const page_four = CART_ITEMS.find(item => item.properties.stepId === "badge");
  const page_five = CART_ITEMS.find(item => item.properties.stepId === "fittings");

  // size + reg name + number + spacing
  if (page_one) {
    state.cart.size = page_one.id;
    /// REG name
    jQuery("#reg_name").val(page_one.properties.Registration);
    changePlatesText(page_one.properties.Registration);
    /// auto width
    let autowidth = page_one.properties["Auto Width"] === 'enabled';
    $('#autowidth').prop('checked', autowidth);
    state.changeWidth.enable = autowidth;
    /// Size
    plate_sizechage(`#${page_one.options_with_values[0].value.handle()}`, page_one.options_with_values[0].value, page_one.properties.Registration);
    jQuery(`input[value="${page_one.options_with_values[0].value}"]`).prop('checked', true);
    /// Number
    jQuery(".number").removeClass("selected");
    updatePlates(`.plate_number #${page_one.options_with_values[1].value.handle()}`, "number");
    jQuery(`.plate_number input[value="${page_one.options_with_values[1].value}"]`).prop('checked', true);
    /// Spacing
    legalSpaceChange(`#${page_one.options_with_values[2].value.handle()}`, page_one.options_with_values[2].value);
    jQuery(`input[value="${page_one.options_with_values[2].value}"]`).prop('checked', true);
  }

  // style
  if (page_two) {
    state.cart.style = page_two.id;
    plate_stylechange(`#${page_two.options_with_values[0].value.handle()}`, page_two.options_with_values[0].value);
    jQuery(`input[value="${page_two.options_with_values[0].value}"]`).prop('checked', true);
  }

  // border color
  if (page_three) {
    state.cart.number = page_three.id;
    jQuery(".thumbnail").removeClass("selected");
    borderColorChange(`#${page_three.options_with_values[0].value.handle()}`);
    jQuery(`input[value="${page_three.options_with_values[0].value}"]`).prop('checked', true);
  }

  /// plate badge
  if (page_four) {
    state.cart.badge = page_four.id;
    /// plate badge
    jQuery(".badge-container").removeClass("selected");
    updatePlates(`#${page_four.options_with_values[0].value.handle()}`, "badge");
    jQuery(`input[value="${page_four.options_with_values[0].value}"]`).prop('checked', true);
  }

  /// plate fittings
  if (page_five) {
    state.cart.fittings = page_five.id;
    jQuery(".plate_fittings .radio_option").removeClass("selected");
    jQuery(`.n_1 #${page_five.options_with_values[0].value.handle()}`).addClass("selected");
    jQuery(`.n_1 input[value="${page_five.options_with_values[0].value}"]`).prop('checked', true);

    jQuery(`.n_2 #${page_five.options_with_values[1].value.handle()}`).addClass("selected");
    jQuery(`.n_2 input[value="${page_five.options_with_values[1].value}"]`).prop('checked', true);

    jQuery(`.n_3 #${page_five.options_with_values[2].value.handle()}`).addClass("selected");
    jQuery(`.n_3 input[value="${page_five.options_with_values[2].value}"]`).prop('checked', true);
  }

}

function changePlatesText(text) {

  if (typeof text === "string") {
    var plateTexts = jQuery('.plate_text');
    if (text.length > MaxTextInput + 1) {
      text = text.substring(text.length - MaxTextInput, text.length);
    } else {
      text = text.substring(0, state.text.factor);
    }

    plateTexts.text(text);
  }

}

function addToElements(elems, attrs) {

  for (const elem of elems) {
    for (const attr in attrs) {
      if (elem && attr) {
        elem.setAttribute(attr, attrs[attr]);
      }
    }
  }

}

function removeElements(...elems) {

  for (elem of elems) {
    elem && elem.remove();
  }

}

function centerPositionInsideSVG({ width, height }, type) {

  if (type === "rear") return;
  state.shape.x = Math.round(svgWidth - width) / 2;
  state.shape.y = Math.round(svgHeight - height) / 2;

}

// svg image X
function getNormalX(id) {

  switch (id) {
    case 1: case 4: case 7: return 83;
    case 3: case 5: case 6: return 60;
    default: return 36;
  }

}

// svg image width
function getNormalW(id) {

  switch (id) {
    case 1: case 4: case 7: return 122;
    case 3: case 5: case 6: return 100;
    default: return 85;
  }

}

// svg image X
function getRectX(id) {

  switch (id) {
    case 1: case 4: case 7: return 80;
    case 3: case 5: case 6: return 67;
    default: return 47;
  }

}

/************
 * Global Shapes Functions
 */


function _config(front = true, rear = true) {
  front && front_config(state);
  rear && rear_config(state);
}

function _createRect(width, height, front = true, rear = true) {

  state.shape.width = width;
  state.shape.height = height;
  state.shape.type = "created";



  front && front_createRect(state);
  rear && rear_createRect(state);
}

function _changeShape(shapeId, front = true, rear = true) {

  state.shape.type = "normal";

  shapeId && (state.shape.id = shapeId);
  front && front_changeShape(shapeId);
  rear && rear_changeShape(shapeId);
}

function _toggleBorder(front = true, rear = true) {
  front && front_toggleBorder();
  rear && rear_toggleBorder();
}

function _toggleBadge(front = true, rear = true) {

  front && front_toggleBadge(state);
  rear && rear_toggleBadge(state);
}

/// "1234" "Arial" "75px"
function getTextWidth(font, fontSize) {
  let text = state.text.value;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = `${fontSize} ${font}`;
  const width = context.measureText(text).width;
  return width;
}

function _autoWidth(front = true, rear = true) {
  front && front_autoWidth();
  rear && rear_autoWidth();
}